import { canOrder } from '@utils/shop';
import getCartShopId from './getShopId';

export default function canInitNewCart({ cart, shop }) {
  return canOrder(shop) && (!cart || getCartShopId(cart) !== shop.id);
}
